import { render } from "./CoreProcessInterface.vue?vue&type=template&id=54ae5afe&scoped=true"
import script from "./CoreProcessInterface.vue?vue&type=script&lang=js"
export * from "./CoreProcessInterface.vue?vue&type=script&lang=js"

import "./CoreProcessInterface.vue?vue&type=style&index=0&id=54ae5afe&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ae5afe"]])

export default __exports__